import { useDispatch, useSelector } from "react-redux";
import { IEditDocumentPopup } from "./edit-document-popup";
import {
  addCommonProperties,
  initialDocumentDataToSave,
  SET_DOCUMENT_DATA_TO_SAVE,
  SET_EPIC_NOTES_SELECTED_ROWS,
} from "./reducers/document-management-reducer";
import React, { useCallback, useEffect } from "react";
import { actions as asyncActions } from "async-ops";
import { bindActionCreators } from "redux";
import DataGrid, {
  Column,
  Pager,
  Paging,
  Selection,
} from "devextreme-react/data-grid";
import { callOperation, actions } from "async-ops";
import { GET_EHR_DOCUMENTS } from "./services/get-ehr-documents";
import { HIDE_LOADER, SHOW_LOADER } from "../mdae-common-reducer";
import {
  EDIT_OR_ATTACH_COMPONENT_MODES,
  EditOrAttachDocument,
} from "./edit-or-attach-document";
import { convertDateFormat } from "../../utils/dateUtils";
import { IMPORT_EHR_DOCUMENTATION } from "./services/import-ehr-documents";
import getDocumentPreviewColumn from "./edit-or-attach-document";

interface IEhrDocumentationComponent extends IEditDocumentPopup {}
const EhrDocumentsComponent: React.FC<IEhrDocumentationComponent> = (props) => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch,
  );
  const dataSourceStoreId = props.uniqueId + EDIT_OR_ATTACH_COMPONENT_MODES.EHR;
  const documentDataToSave: Array<typeof initialDocumentDataToSave> = useSelector(
    (state: any) =>
      state["documentManagementReducer"].documentDataToSaveStore[
        dataSourceStoreId
      ],
  );
  const ehrDocuments = useSelector(
    (state: any) =>
      state["documentManagementReducer"].ehrConnectorData.ehrDocuments,
  );

  const attachedLevelName = useSelector(
    (state) => state["documentManagementReducer"].attachedLevelName
  );
  const attachedLevelId = useSelector(
    (state) => state["documentManagementReducer"].attachedLevelId
  );
  const completeCaseDetail = useSelector(
    (state) => state["caseDetailReducer"].completeCaseDetail
  );

  const dataGridOnSelectionChanged = useCallback((e) => {
    dispatch({
      type: SET_EPIC_NOTES_SELECTED_ROWS,
      data: { selectedEhrDocuments: e.selectedRowKeys },
    });
  }, []);

  useEffect(() => {
    const dateOfBirth = completeCaseDetail?.dateOfBirth;
    const mrn = completeCaseDetail?.patientMRN;
    const lastName = completeCaseDetail?.patientLastName;
    const firstName = completeCaseDetail?.patientFirstName;
    const dateStart = completeCaseDetail?.statementFromDate
      ? convertDateFormat(completeCaseDetail.statementFromDate, "YYYY-MM-DD")
      : undefined;
    const dateEnd = completeCaseDetail?.statementToDate
      ? convertDateFormat(completeCaseDetail.statementToDate, "YYYY-MM-DD")
      : undefined;
    asyncAction.asyncOperationStart(GET_EHR_DOCUMENTS, {
      dateOfBirth,
      mrn,
      lastName,
      firstName,
      dateStart,
      dateEnd,
    });
  }, []);

  return (
    <>
      <div className={documentDataToSave?.length == 0 ? "hide-control" : ""}>
        <EditOrAttachDocument
          {...props}
          mode={EDIT_OR_ATTACH_COMPONENT_MODES.EHR}
        />
      </div>
      <div
        style={{ marginTop: 10 }}
        className={documentDataToSave?.length > 0 ? "hide-control" : ""}
      >
        <DataGrid
          id={props.uniqueId + "_grdEhrDocuments"}
          dataSource={ehrDocuments}
          keyExpr={"binaryId"}
          onSelectionChanged={dataGridOnSelectionChanged}
        >
          <Paging defaultPageSize={8} />
          <Pager
            showPageSizeSelector={true}
            showNavigationButtons={true}
            allowedPageSizes={[4, 8]}
            showInfo={true}
          />
          {getDocumentPreviewColumn(
            asyncAction,
            attachedLevelId,
            attachedLevelName,
            dispatch,
          )}
          <Column dataField="type" caption="Type" />
          <Column dataField="category" caption="Category" />
          <Column dataField="participants" caption="Participants" />
          <Column dataField="dateStart" caption="Service From" />
          <Column dataField="dateEnd" caption="Service To" />
          <Selection mode={"multiple"} />
        </DataGrid>
      </div>
    </>
  );
};
export const importEhrDocumentation = (uniqueId) => {
  return (dispatch, getState) => {
    const state = getState();
    const ehrDocuments = state["documentManagementReducer"].ehrConnectorData.ehrDocuments;
    const selectedEhrDocuments: any[] =
      state["documentManagementReducer"].ehrConnectorData.selectedEhrDocuments;

    const documentsToImport = selectedEhrDocuments.map((selectedNoteId) => {
      const selectedNote = ehrDocuments.find(
        (note) => note.binaryId === selectedNoteId,
      );
      return {
        binaryId: selectedNote.binaryId,
        contentType: selectedNote.contentType,
        documentStorageBaseKey: "doc-repo/ehr/"
      };
    });

    dispatch({ type: SHOW_LOADER });
    callOperation(IMPORT_EHR_DOCUMENTATION, {
      ehrDocumentReadInformation: documentsToImport,
    }).then((response) => {
      dispatch({ type: HIDE_LOADER });
      response.forEach((x) => {
        const selectedNote = ehrDocuments.find(
          (note) => note.binaryId === x.binaryId,
        );
        addCommonProperties(x);
        x.documentName = `${selectedNote.type} - ${selectedNote.category}`;
        x.s3ObjectName = x.key;
        x.originalFileName = (x.key as string).split("/").slice(-1)[0];
        x.uploadProgress = null;
      });

      dispatch({
        type: SET_DOCUMENT_DATA_TO_SAVE,
        data: {
          documentDataToSave: response,
          uniqueId: uniqueId,
        },
      });
    });
  };
};


export default EhrDocumentsComponent;
